import Vue from 'vue';
import VueRouter from 'vue-router';

import Sittercity from './sittercity';
import { setupApollo } from '../lib/apollo_setup';
import setupFooter from '@/lib/setup_footer';
import BhBenefits from '../apps/bh_benefits/BhBenefits.vue';
import Generic from '../apps/bh_benefits/Generic.vue';
import ClientSpecific from '../apps/bh_benefits/ClientSpecific.vue';
import SignUp from '../apps/bh_benefits/SignUp.vue';
import BHBenefitRoutes from '@/lib/constants/bh_benefit_route_names';
import UpgradeFlow from '../apps/bh_benefits/upgrade/UpgradeFlow.vue';

import { sendSegmentPageview } from '../lib/segment';

declare let google: any;
document.addEventListener('DOMContentLoaded', () => {
  if (typeof google === 'undefined') {
    google = null;
  }

  Vue.use(VueRouter);

  const appNode = document.getElementById('app');

  const routes = [
    {
      name: BHBenefitRoutes.HOME,
      path: '/',
      component: Generic,
      meta: { pageTrackingName: 'Corporate: Homepage', pageTrackingTitle: 'Sittercity: Bright Horizons Corporate Benefits' },
    },
    {
      name: BHBenefitRoutes.UPGRADE,
      path: '/upgrade',
      component: UpgradeFlow,
    },
    {
      path: '/:slug',
      name: BHBenefitRoutes.SIGNUP,
      component: ClientSpecific,
      meta: { pageTrackingName: 'Corporate: Homepage', pageTrackingTitle: 'Sittercity: Bright Horizons Corporate Benefits' },
      props: true,
    },
    {
      name: BHBenefitRoutes.YA_SIGNUP,
      path: '/:slug/signup',
      component: SignUp,
      meta: {
        pageTrackingName: 'Corporate: Sign Up',
        pageTrackingTitle: 'Sittercity: Bright Horizons Corporate Benefits - Sign Up',
      },
      props(route) {
        return { slug: route.params.slug, google };
      },
      beforeEnter(to, from, next) {
        if (to.query.site === 'years_ahead') {
          next();
        } else {
          next({ name: BHBenefitRoutes.SIGNUP, params: { slug: to.params.slug }, query: to.query });
        }
      },
    },
  ];

  const router = new VueRouter({
    mode: 'history',
    base: '/bh-benefits',
    routes,
    scrollBehavior(to, _, savedPosition) {
      if (to.name === BHBenefitRoutes.SIGNUP) {
        return { x: 0, y: 0 };
      }
      return savedPosition;
    },
  });

  router.afterEach((to) => {
    let pageName = to?.meta?.pageTrackingName;
    let title = to?.meta?.pageTrackingTitle;

    const yearsAhead = to?.query?.site === 'years_ahead';
    if (yearsAhead) {
      pageName += ' - Years Ahead';
      title += ' - Years Ahead';
    }

    if (pageName) {
      document.title = title;

      // setting url and path explicitly because segment uses canonical url by default
      sendSegmentPageview(pageName, {
        url: document.location.href,
        path: document.location.pathname,
      });
    }
  });

  if (appNode == null) {
    throw new Error('App node not found. Aborting.');
  }

  setupFooter();

  const apolloProvider = setupApollo();

  new Sittercity({
    name: 'BH Benefits Page',
    render(createElement) {
      return createElement(BhBenefits);
    },
    router,
    apolloProvider,
  }).$mount('#app');
});
